
<header>
	<h1>
		An Introduction and Guide to Pāli Pronunciation and Grammar
	</h1>
	
	<div class="byline">
		<address class="author">By <span rel="author">Klaus Nothnagel</span></address> 	
	</div>
</header>

<section id="intro-text-ipg" class="section-divider-intro-ipg" aria-labelledby="introduction-ipg">
	<p class="lg-pali-center-ipg">Namo tassa bhagavato arahato sammāsambuddhassa</p>
	<p class="pali-italic-center-ipg">
		Jāge jāge dharama kī vāṇī<br>
		Maṅgala mūla mahā kalyānī<br>
		Maṅgala mūla mahā kalyānī <br>
		Jāge jāge dharama kī vāṇī
	</p>

	<p class="english-translation-center-ipg">
		May the words of the Dhamma arise,<br>
		Those roots of great happiness and well-being,<br>
		Those roots of great happiness and well-being,<br>
		May the words of the Dhamma arise!
	</p>

	<footer class="byline-container-ipg">
		<p class="byline-ipg">&mdash;Hindi dohas by S. N. Goenka during his 10-day courses</p>
	</footer>
</section>

<style>
	header, section {
		text-align: center;
		margin: 0 0 5% 0;
	}

	p {
		font-size: 1.2rem;
	}

	footer p.byline-ipg {
		font-style: italic;
		font-size: 1rem;
		text-align: right;
	}
	
	.lg-pali-center-ipg {
		font-style:italic;
		margin: 0;
	}

	section#intro-text-ipg {
		padding: 0;
	}

	address.author {
		font-style: normal;
	}
</style>